import React from 'react';
import {useState, useRef, useEffect} from 'react';
import {useNavigate, useLocation, Link} from 'react-router-dom';
import './navbar.scss'; // Or './Navbar.css' if you're using CSS
import company from '../../assets/images/company2.png'
import { getEnabledServices } from '../../config/services';

function Navbar() {
    const navigate = useNavigate();
    const location = useLocation();

    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };
    const [showServices, setShowServices] = useState(false);
    const [showCaseStudies, setShowCaseStudies] = useState(false);
    const [servicesColor, setServicesColor] = useState('#ffffff');
    const [caseStudiesColor, setCaseStudiesColor] = useState('#ffffff');
    const servicesTimer = useRef(null);
    const caseStudiesTimer = useRef(null);
    const dropdownRef = useRef(null);

    const enabledServices = getEnabledServices();

    const handleMouseEnter = (setter) => {
        clearTimeout(servicesTimer.current);
        clearTimeout(caseStudiesTimer.current);
        setter(true);
    };

    const handleMouseLeave = (setter) => {
        clearTimeout(servicesTimer.current);
        clearTimeout(caseStudiesTimer.current);
        setter(false);
    };

    const handleServiceClick = () => {
        if (location.pathname === '/') {
            const section = document.getElementById('our-service-section');
            if (section) {
                section.scrollIntoView({behavior: 'smooth'});
            }
        } else {
            navigate('/#our-service-section');
        }
    };

    // Clear all dropdown states
    const clearAllDropdowns = () => {
        setShowServices(false);
        setShowCaseStudies(false);
    };

    useEffect(() => {
        function handleResize() {
            const currentIsMobile = window.innerWidth <= 768;
            setIsMobile(currentIsMobile);

            if (!currentIsMobile && isMobileMenuOpen) {
                setIsMobileMenuOpen(false);
            }

            if (currentIsMobile && !isMobileMenuOpen) {
                setIsMobileMenuOpen(true);
            }
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [isMobileMenuOpen, isMobile]);

    useEffect(() => {
        if (isMobile) {
            setIsMobileMenuOpen(true);
        }
    }, [location, isMobile]);

    // Add click outside handler
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowCaseStudies(false);
                setCaseStudiesColor('#ffffff');
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Handle Services click
    const handleServicesClick = (e) => {
        e.preventDefault();
        if (showServices) {
            setShowServices(false);
            setServicesColor('#ffffff');
        } else {
            setShowServices(true);
            setShowCaseStudies(false);
            setServicesColor('#00adee');
            setCaseStudiesColor('#ffffff');
        }
    };

    // Handle Case Studies click
    const handleCaseStudiesClick = (e) => {
        e.preventDefault();
        if (showCaseStudies) {
            setShowCaseStudies(false);
            setCaseStudiesColor('#ffffff');
        } else {
            setShowCaseStudies(true);
            setShowServices(false);
            setCaseStudiesColor('#00adee');
            setServicesColor('#ffffff');
        }
    };

    return (
        <nav className="navbar">
            <div className="navbar-logo">
                {/*<a href="/">Majority AI</a>*/}
                <Link to='/'>
                    <img className={"img-zoom"} src={company} alt="Company Logo" style={{ height: '50px' }} />
                </Link>
            </div>
            <div className="hamburger" onClick={toggleMobileMenu}>
                &#9776;
            </div>
            <ul className={`navbar-links ${isMobileMenuOpen ? 'show' : ''}`}
                style={{display: isMobileMenuOpen ? 'none' : 'flex'}}>
                {/*<ul className={`navbar-links ${isMobileMenuOpen ? 'show' : ''}`}>*/}

                <li
                    onMouseEnter={() => handleMouseEnter(setShowServices)}
                    onMouseLeave={() => handleMouseLeave(setShowServices)}
                >
                    <button 
                       onClick={handleServicesClick}
                       style={{ color: servicesColor }}
                       className="nav-button"
                    >Services</button>
                    {showServices && (
                        <div className={`services-dropdown ${showServices ? 'visible' : 'hidden'}`}>
                            {enabledServices.map(service => (
                                <Link key={service.id} to={service.path} onClick={() => {
                                    setShowServices(false);
                                    setServicesColor('#ffffff');
                                }}>{service.name}</Link>
                            ))}
                        </div>
                    )}
                </li>
                {/*这是有用的不能删，这里是navbar顶上面的solutions和industry部分，暂时没做好先隐藏了*/}
                {/*这是有用的不能删，这里是navbar顶上面的solutions和industry部分，暂时没做好先隐藏了*/}
                {/*这是有用的不能删，这里是navbar顶上面的solutions和industry部分，暂时没做好先隐藏了*/}

                {/*<li*/}
                {/*    onMouseEnter={() => handleMouseEnter(setShowSolutions, solutionsTimer)}*/}
                {/*    onMouseLeave={() => handleMouseLeave(setShowSolutions, solutionsTimer)}*/}
                {/*>*/}
                {/*    <a href="#">Solutions</a>*/}
                {/*    {showSolutions && (*/}
                {/*        <div className={`solutions-dropdown ${showSolutions ? 'visible' : 'hidden'}`}>*/}
                {/*            <a href="/virtual-assistant-tool">Virtual Assistant Tool</a>*/}
                {/*            <a href="/custom-large-language-models">Custom Large Language Models</a>*/}
                {/*            <a href="/natural-language-processing">Natural Language Processing</a>*/}
                {/*        </div>*/}
                {/*    )}*/}
                {/*</li>*/}

                {/*<li*/}
                {/*    onMouseEnter={() => handleMouseEnter(setShowIndustries, industriesTimer)}*/}
                {/*    onMouseLeave={() => handleMouseLeave(setShowIndustries, industriesTimer)}*/}
                {/*>*/}
                {/*    <a href="#">Industries</a>*/}
                {/*    {showIndustries && (*/}
                {/*        <div className={`industries-dropdown ${showIndustries ? 'visible' : 'hidden'}`}>*/}
                {/*            <a href="/healthcare">Healthcare</a>*/}
                {/*            <a href="/finance">Finance</a>*/}
                {/*            <a href="/education">Education</a>*/}
                {/*        </div>*/}
                {/*    )}*/}
                {/*</li>*/}

                {/*这是有用的不能删，这里是navbar顶上面的solutions和industry部分，暂时没做好先隐藏了*/}
                {/*这是有用的不能删，这里是navbar顶上面的solutions和industry部分，暂时没做好先隐藏了*/}
                {/*这是有用的不能删，这里是navbar顶上面的solutions和industry部分，暂时没做好先隐藏了*/}


                <li
                    ref={dropdownRef}
                    onMouseEnter={() => handleMouseEnter(setShowCaseStudies)}
                    onMouseLeave={() => handleMouseLeave(setShowCaseStudies)}
                >
                    <button 
                       onClick={handleCaseStudiesClick}
                       style={{ color: caseStudiesColor }}
                       className="nav-button"
                    >Case Studies</button>
                    {showCaseStudies && (
                        <div className={`case-studies-dropdown ${showCaseStudies ? 'visible' : 'hidden'}`}>
                            <Link to="/llm" onClick={() => {
                                setShowCaseStudies(false);
                                setCaseStudiesColor('#ffffff');
                            }}>LLM</Link>
                            <Link to="/cv" onClick={() => {
                                setShowCaseStudies(false);
                                setCaseStudiesColor('#ffffff');
                            }}>Computer Vision</Link>
                            <Link to="/reinforcementlearning" onClick={() => {
                                setShowCaseStudies(false);
                                setCaseStudiesColor('#ffffff');
                            }}>Reinforcement Learning</Link>
                        </div>
                    )}
                </li>

                {/*这是有用的不能删，这里是navbar顶上面的About，暂时没做好先隐藏了*/}
                {/*<li><a href="/about">About</a></li>*/}
                {/*这是有用的不能删，这里是navbar顶上面的About，暂时没做好先隐藏了*/}

                <li><Link to="/about">Why us</Link></li>
                <li><Link to="/contact">Contact Us</Link></li>
            </ul>
        </nav>
    );
}

export default Navbar;


